import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
import { clone } from '../util/object.js';
import { createOAuthMeta } from './util/oauthMeta.js';
import { prepareTokenParams } from './util/prepareTokenParams.js';
import './types/Token.js';
import { buildAuthorizeParams } from './endpoints/authorize.js';
function getWithRedirect(_x, _x2) {
  return _getWithRedirect.apply(this, arguments);
}
function _getWithRedirect() {
  _getWithRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdk, options) {
    var tokenParams,
      meta,
      requestUrl,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(_args.length > 2)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", Promise.reject(new AuthSdkError('As of version 3.0, "getWithRedirect" takes only a single set of options')));
        case 2:
          options = clone(options) || {};
          _context.next = 5;
          return prepareTokenParams(sdk, options);
        case 5:
          tokenParams = _context.sent;
          meta = createOAuthMeta(sdk, tokenParams);
          requestUrl = meta.urls.authorizeUrl + buildAuthorizeParams(tokenParams);
          sdk.transactionManager.save(meta);
          if (sdk.options.setLocation) {
            sdk.options.setLocation(requestUrl);
          } else {
            window.location.assign(requestUrl);
          }
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getWithRedirect.apply(this, arguments);
}
export { getWithRedirect };